import { Route } from '@angular/router';

export default [] satisfies Route[];
